var map = {
	"./Exim bank.jpg": 41191,
	"./MSBank.jpg": 13482,
	"./NCBBank.jpg": 78177,
	"./OCB.jpg": 78470,
	"./SCB-Copy.jpg": 53742,
	"./vietcombank.jpg": 29515,
	"./vietinbank.png.jpg": 46504,
	"Common/Components/AppFooter/Assets/Icons/Vn/Exim bank.jpg": 41191,
	"Common/Components/AppFooter/Assets/Icons/Vn/MSBank.jpg": 13482,
	"Common/Components/AppFooter/Assets/Icons/Vn/NCBBank.jpg": 78177,
	"Common/Components/AppFooter/Assets/Icons/Vn/OCB.jpg": 78470,
	"Common/Components/AppFooter/Assets/Icons/Vn/SCB-Copy.jpg": 53742,
	"Common/Components/AppFooter/Assets/Icons/Vn/vietcombank.jpg": 29515,
	"Common/Components/AppFooter/Assets/Icons/Vn/vietinbank.png.jpg": 46504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31882;